import {MetaTags} from '@frontend/components/MetaTags'
import {trans} from '@frontend/helpers'
import {useConfigureUi} from '@frontend/hooks'
import {PopularCategories} from '@frontend/modules/public/ads/components/PopularCategories'
import {HomePageAdsSection} from '@frontend/modules/public/home/components/HomePageAdsSection'

// Главная страница сайта.
export default function HomePage() {

    // Настройка глобальных элементов интерфейса приложения.
    useConfigureUi(config => {
        config.topMenu.wrapInCard = true
        config.topMenu.stickToTop = true
        return config
    })

    return (
        <div className="container-fluid container-xl">
            <MetaTags
                title={trans().common.home_page_title}
            />
            <PopularCategories />
            <div className="flex-1 pb-4">
                <HomePageAdsSection />
            </div>
        </div>
    )
}
